import {
  CatmullRomCurve3,
  ExtrudeGeometry,
  Group,
  Matrix4,
  Mesh,
  MeshPhongMaterial,
  Object3D,
  PlaneGeometry,
  Shape,
  Vector3,
} from "three";
import { Geometry } from "oc-threejs/geometries/Geometry";
import { ThreeBSP } from "oc-threejs/ThreeBSP";
import { v3 } from "oc-threejs/short3";
import * as Commons from "oc-commons/Commons";
import { UniversalLoader } from "oc-threejs/loader/UniversalLoader";
import { BoxUvBufferGeometry } from "oc-threejs/geometries/BoxUvBufferGeometry";
import { ConvexUvBufferGeometry } from "oc-threejs/geometries/ConvexUvBufferGeometry";

const boxGeom = (...args: any[]) => new (BoxUvBufferGeometry as any)(...args);
const dachPrismaGeo = (grundseite, hoehe, breite) => {
  const points = [
    v3(breite / 2, -hoehe / 2, -grundseite / 2), //unten hinten rechts
    v3(breite / 2, -hoehe / 2, grundseite / 2), //unten vorne rechts
    v3(breite / 2, hoehe / 2, 0), //oben rechts
    v3(-breite / 2, -hoehe / 2, -grundseite / 2), //unten hinten links
    v3(-breite / 2, -hoehe / 2, grundseite / 2), //unten vorne links
    v3(-breite / 2, hoehe / 2, 0), //oben links
  ];
  return new ConvexUvBufferGeometry(points, new Matrix4().makeRotationZ(Math.PI / 2));
};

const shadowize = (mesh: Mesh) => {
  mesh.castShadow = true;
  mesh.receiveShadow = true;
  return mesh;
};

const createMesh = (...args: any[]) => shadowize(new Mesh(...args));

const bsp = (mesh: Mesh) => ThreeBSP.getBSPs(mesh)[0];

const subtract_mesh = (a_mesh, b_mesh) =>
  shadowize(bsp(a_mesh).subtract(bsp(b_mesh)).toMesh(a_mesh.material));

export function createHaus3d(params: any) {
  params = Commons.defaultsDeepSafe(params, {
    size: v3(),
    a: 5,
    b: 5,
    margin: 0.01,
    shadow: true,
    contactPositions: [],
  });
  const materials = UniversalLoader.getMaterialFactory();
  const material_roof = materials.create("Dachziegel");
  const material_wall = materials.create("Hauswand");
  const material_white = materials.create("Fensterrahmen");
  const material_grey = material_white;
  const material_glas = materials.create("Fensterglas");
  const material_cut_invisible = new MeshPhongMaterial({
    color: "blue",
    visible: false,
  });

  function create_profile_geometry(type, x, y, z, teselation, x2, y2, z2) {
    teselation = 300;

    if (type == "door") {
      const height = y,
        width = x;

      const door_shape = new Shape();

      door_shape.moveTo(-width, -height * 0.8);
      door_shape.lineTo(-width, 0);
      door_shape.lineTo(-width, 0);
      door_shape.lineTo(0, 0);
      door_shape.lineTo(0, -height);
      door_shape.lineTo(0, -height);
      door_shape.lineTo(-width, -height * 0.6); //.3

      //new THREE.CatmullRomCurve3([  SplineCurve3
      // x2 = y2;
      const spline = new CatmullRomCurve3([
        new Vector3(0 * x2, 0 * y2, 0),
        new Vector3(0 * x2, 1 * y2, 0),
        new Vector3(1 * x2, 1 * y2, 0),
        new Vector3(1 * x2, 0 * y2, 0),
        new Vector3(0 * x2, 0 * y2, 0),
      ]);

      spline.curveType = "catmullrom";
      spline.tension = 0.0;
      //  spline.curveType = 'catmullrom';// 'chordal';

      const door_extrudeSettings = {
        bevelEnabled: false,
        curveSegments: 0,
        //	amount: 10,
        //	bevelEnabled: true,
        //	bevelThickness: height*0.1,
        //	bevelSize: 0.005,
        //	bevelSegments: 1,
        extrudePath: spline,
        steps: teselation,
        //depth:100
      };

      const part1 = new ExtrudeGeometry(door_shape, door_extrudeSettings);
      return part1;
    }

    if (type == "roof_edge") {
      const house_depth = z2;
      const house_width = x2;
      const g_1 = house_width;
      const g_2 = house_depth - params.f;
      const g_3 = params.g;
      const g_4 = params.f;
      const g_5 = params.e - params.margin * 2;
      const g_6 = params.d;
      const g_7 = params.c;
      const g_8 = house_depth - params.d;

      const height = y,
        width = x / 2;

      const door_shape = new Shape();

      door_shape.moveTo(-width, -height * 0.8);
      door_shape.lineTo(-width, 0);
      door_shape.lineTo(-width, 0);
      door_shape.lineTo(width, 0);
      door_shape.lineTo(width, -height);
      door_shape.lineTo(0, -height);
      door_shape.lineTo(-width, -height * 0.6); //.3

      //new THREE.CatmullRomCurve3([  SplineCurve3
      // x2 = y2;
      //  const spline =  new THREE.SplineCurve3([
      const spline = new CatmullRomCurve3([
        new Vector3(0.0, 0.0, 0.0),
        new Vector3(g_1, 0.0, 0.0),
        new Vector3(g_1, 0.0, g_2),
        new Vector3(g_1 / 2 + g_5 / 2, 0.0, g_2),
        new Vector3(g_1 / 2 + g_5 / 2, 0.0, g_2 + g_4),
        new Vector3(g_1 / 2 - g_5 / 2, 0.0, g_8 + g_6),
        new Vector3(g_1 / 2 - g_5 / 2, 0.0, g_8),
        new Vector3(0.0, 0.0, g_8),
        new Vector3(0.0, 0.0, 0.0),
      ]);
      spline.tension = 0.0;
      spline.curveType = "catmullrom"; //'centripetal';//'catmullrom';// 'chordal';

      const door_extrudeSettings = {
        bevelEnabled: false,
        curveSegments: 1,
        //	amount: 10,
        //	bevelEnabled: true,
        //	bevelThickness: height*0.1,
        //	bevelSize: 0.005,
        //	bevelSegments: 1,
        extrudePath: spline,
        steps: 400,
      };

      const part1 = new ExtrudeGeometry(door_shape, door_extrudeSettings);
      return part1;
    }
  }

  //////////////creation for realtime update////////////////

  let house_shadow = false;

  if (params.shadow && params.shadow == true) house_shadow = true;

  const a = params.a;
  const b = params.b;
  const c = params.c + params.margin;
  const d = params.d;
  const e = params.e - params.margin * 2;
  const f = params.f;
  const g = params.g + params.margin;
  const h = params.h;

  const house_width = params.size.x;
  const house_height = params.size.y;
  const house_depth = params.size.z;

  const terasse_height = 0.05;
  const sockel_height = 0.1 + terasse_height;

  const biggest_U = {
    value: d,
    name: "d",
    value_added_sides: h,
  };

  if (h > b) {
    biggest_U.value = f;
    biggest_U.name = "f";
    biggest_U.value_added_sides = b;
  }

  let b_or_h = b;
  if (h > b) {
    b_or_h = h;
  }

  // const house_depth_defaults = [7, 10, 10, 6 + b_or_h];
  // const house_depth = house_depth_defaults[house_type];

  const houseGroup = new Group();

  const houseTemplate = new Object3D();
  houseTemplate.name = "house_template";

  houseGroup.add(houseTemplate);

  //horizon

  let erker_center_width = e;
  let erker_left_width = house_width / 2 - erker_center_width / 2;
  let erker_left_depth = d;

  let erker_right_width = house_width / 2 - erker_center_width / 2;
  let erker_right_depth = f;

  let erker_incut_max = 1000;

  erker_left_width = 0.0;
  erker_left_depth = 0.0;
  erker_right_width = 0.0;
  erker_right_depth = 0.0;

  const cut_cube_geo = boxGeom(1, 1, 1);
  const cut_cube_mesh = createMesh(cut_cube_geo, material_cut_invisible);
  houseTemplate.add(cut_cube_mesh);

  let Sockel_A_geo = boxGeom(house_width, sockel_height, house_depth);
  let Sockel_A_mesh = createMesh(Sockel_A_geo, material_wall);
  Sockel_A_mesh.position.y = -sockel_height / 2;

  // const HouseBody_A_geo = createBoxWithRoundedEdges( house_width, house_height,house_depth, 0.01, 1 );
  // const HouseBody_A_geometry = new THREE.Geometry().fromBufferGeometry(HouseBody_A_geo);
  const HouseBody_A_geometry = boxGeom(house_width, house_height, house_depth, 2);

  let HouseBody_A_mesh = createMesh(HouseBody_A_geometry, material_wall);

  HouseBody_A_mesh.position.y = house_height / 2;

  // roof   type 0
  const roof_width = house_width + 0.5;
  const roof_angle = Math.PI / 4;
  const roof_depth = 0.5 * roof_width * (1 / Math.cos(roof_angle));

  const house_height_floor2 = house_depth / 2;
  const HouseBody_A_geometry_floor2 = dachPrismaGeo(house_depth, house_height_floor2, house_width); //boxGeom(house_width, house_height_floor2, house_depth, 2);

  const HouseBody_A_mesh_floor2 = createMesh(HouseBody_A_geometry_floor2, material_wall);
  HouseBody_A_mesh_floor2.position.y = house_height + house_height_floor2 / 2;
  houseTemplate.add(HouseBody_A_mesh_floor2);

  const roof_geometry = boxGeom(
    0.5 * house_depth * (1 / Math.cos(roof_angle)) + 0.2,
    0.08,
    roof_width
  );
  const roof_mesh = createMesh(roof_geometry, material_roof);
  roof_mesh.rotation.z = roof_angle;
  roof_mesh.rotation.y = -Math.PI / 2;
  roof_mesh.position.y = house_height + house_height_floor2 / 2 + Math.sin(roof_angle) * 0.05 - 0.1;
  roof_mesh.position.z = -house_depth / 4 - 0.05;
  houseTemplate.add(roof_mesh);

  const roof2_geometry = boxGeom(
    0.5 * house_depth * (1 / Math.cos(roof_angle)) + 0.2,
    0.08,
    roof_width
  );
  const roof2_mesh = createMesh(roof2_geometry, material_roof);
  roof2_mesh.rotation.z = roof_angle;
  roof2_mesh.rotation.y = Math.PI / 2;
  roof2_mesh.position.y =
    house_height + house_height_floor2 / 2 + Math.sin(roof_angle) * 0.05 - 0.1;
  roof2_mesh.position.z = house_depth / 4 + 0.05;
  houseTemplate.add(roof2_mesh);

  function create_front_deko(pos_x, pos_y, width, height, statics_count, house_side, erker_option) {
    let erker_offset = 0.0;

    if (erker_option == "left") erker_offset = erker_left_depth;
    if (erker_option == "right") erker_offset = erker_right_depth;

    cut_cube_mesh.scale.x = width;
    cut_cube_mesh.scale.y = height;
    cut_cube_mesh.scale.z = width;

    cut_cube_mesh.position.x = pos_x;
    cut_cube_mesh.position.y = pos_y;
    cut_cube_mesh.position.z = house_depth / 2 - erker_offset;

    if (house_side == "side_left") {
      cut_cube_mesh.position.x = -house_width / 2 + erker_offset;
      cut_cube_mesh.position.y = pos_y;
      cut_cube_mesh.position.z = pos_x;
    }

    if (house_side == "side_right") {
      cut_cube_mesh.position.x = house_width / 2 - erker_offset;
      cut_cube_mesh.position.y = pos_y;
      cut_cube_mesh.position.z = pos_x;
    }

    HouseBody_A_mesh = subtract_mesh(HouseBody_A_mesh, cut_cube_mesh);

    const deko_width = width;
    const deko_height = height;
    const deko_offset_out = 0.16;
    const deko_geometry = create_profile_geometry(
      "door",
      0.13,
      0.06,
      0.03,
      300,
      deko_width + 0.02,
      deko_height + 0.02,
      0.1
    );
    deko_geometry.center();
    const deko_mesh = createMesh(deko_geometry, material_white);

    deko_mesh.position.x = pos_x;
    deko_mesh.position.y = pos_y;
    deko_mesh.position.z = house_depth / 2 - deko_offset_out - erker_offset;

    if (house_side == "side_left") {
      deko_mesh.position.x = -house_width / 2 + deko_offset_out;
      deko_mesh.position.y = pos_y;
      deko_mesh.position.z = pos_x;

      deko_mesh.rotation.y = -Math.PI / 2;
    }

    if (house_side == "side_right") {
      deko_mesh.position.x = house_width / 2 - deko_offset_out;
      deko_mesh.position.y = pos_y;
      deko_mesh.position.z = pos_x;

      deko_mesh.rotation.y = +Math.PI / 2;
    }

    houseTemplate.add(deko_mesh);

    //glas
    const glas_geo = new PlaneGeometry(deko_width, deko_height, 1);
    const glas_mesh = createMesh(glas_geo, material_glas);

    glas_mesh.position.x = pos_x;
    glas_mesh.position.y = pos_y;
    glas_mesh.position.z = house_depth / 2 - deko_offset_out - erker_offset;

    if (house_side == "side_left") {
      glas_mesh.position.x = -house_width / 2 + deko_offset_out;
      glas_mesh.position.y = pos_y;
      glas_mesh.position.z = pos_x;
      glas_mesh.rotation.y = -Math.PI / 2;
    }

    if (house_side == "side_right") {
      glas_mesh.position.x = house_width / 2 - deko_offset_out;
      glas_mesh.position.y = pos_y;
      glas_mesh.position.z = pos_x;
      glas_mesh.rotation.y = +Math.PI / 2;
    }

    houseTemplate.add(glas_mesh);

    //brett

    const brett_geo = boxGeom(deko_width, 0.02, 0.4);
    const brett_mesh = createMesh(brett_geo, material_grey);

    brett_mesh.position.x = pos_x;
    brett_mesh.position.y = pos_y - deko_height / 2;
    brett_mesh.position.z = house_depth / 2 - erker_offset - deko_offset_out;
    brett_mesh.scale.y = 0.5;

    if (house_side == "side_left") {
      brett_mesh.position.x = -house_width / 2 + deko_offset_out;
      brett_mesh.position.y = pos_y - deko_height / 2;
      brett_mesh.position.z = pos_x;
      brett_mesh.rotation.y = -Math.PI / 2;
    }

    if (house_side == "side_right") {
      brett_mesh.position.x = +house_width / 2 - deko_offset_out;
      brett_mesh.position.y = pos_y - deko_height / 2;
      brett_mesh.position.z = pos_x;
      brett_mesh.rotation.y = +Math.PI / 2;
    }

    houseTemplate.add(brett_mesh);

    //strebe
    const streben_main = new Object3D();
    const max_space = 1.1;

    const streben_count = Math.floor(deko_width / max_space);
    const strebe_space = deko_width / (1 + streben_count);

    for (let i = 0; i < streben_count; i++) {
      const strebe_geo = boxGeom(0.05, deko_height, 0.05);
      const strebe_mesh = createMesh(strebe_geo, material_white);

      strebe_mesh.position.x = pos_x - deko_width / 2 + strebe_space * i + strebe_space;
      strebe_mesh.position.y = pos_y;
      strebe_mesh.position.z = house_depth / 2 - deko_offset_out - erker_offset;

      if (house_side == "side_left") {
        strebe_mesh.position.x = -house_depth / 2 + deko_offset_out;
        strebe_mesh.position.y = pos_y;
        strebe_mesh.position.z = pos_x - deko_width / 2 + strebe_space * i + strebe_space;
      }

      if (house_side == "side_right") {
        strebe_mesh.position.x = +house_depth / 2 - deko_offset_out;
        strebe_mesh.position.y = pos_y;
        strebe_mesh.position.z = pos_x - deko_width / 2 + strebe_space * i + strebe_space;
      }
      streben_main.add(strebe_mesh);
    }
    houseTemplate.add(streben_main);
  }

  //create erker - side
  //side

  //creations

  const collisionThreshold = 0.1;
  const collisionSpace = 0.1;
  const frontColissions = params.contactPositions.filter(
    (v) => Math.abs(v.z - house_depth / 2) < collisionThreshold
  );

  const getCollisions = (pos_x, width) =>
    frontColissions.filter(
      (v) => pos_x - width / 2 < v.x + collisionSpace && pos_x + width / 2 > v.x - collisionSpace
    );
  const collidates = (pos_x, width) =>
    frontColissions.some(
      (v) => pos_x - width / 2 < v.x + collisionSpace && pos_x + width / 2 > v.x - collisionSpace
    );
  const splitIntervall = (pos_x, width) => {
    const collisions = getCollisions(pos_x, width).map((v) => v.x);
    const intervalls = [[pos_x - width / 2, pos_x + width / 2]];
    for (const collision of collisions) {
      const i = intervalls.findIndex(([a, b]) => a <= collision && collision <= b);
      if (i >= 0) {
        const newI = [
          [intervalls[i][0], collision - collisionSpace],
          [collision + collisionSpace, intervalls[i][1]],
        ].filter(([a, b]) => a < b);
        intervalls.splice(i, 1, ...newI);
      }
    }
    return intervalls;
  };
  const maxIntervall = (pos_x, width) =>
    splitIntervall(pos_x, width).reduce((a, b) => (a[1] - a[0] > b[1] - b[0] ? a : b), [0, 0]);

  /**
   * Front:
   * a<3.5 : |0.25 Wand |* Tür | 0.25 Wand|
   * a<4.5 : |* Wand |3.0 Tür | * Wand|
   * sonst : |0.65 Wand |0.7 Fenster |* Wand min 0.4 |3.0 Tür | * Wand min 0.4|0.7 Fenster |0.65 Wand|
   */

  const min_center_width = 1;
  const max_center_width = 3;
  const min_wall_space = 0.25;
  const window_width = 0.7;
  const window_height = 1.2;
  const window_space = 0.4;

  const baseSpace = house_width - 2 * min_wall_space;
  const windowBaseSpace = baseSpace - 2 * window_width - 4 * window_space;

  function findDoor(has_windows) {
    const space = has_windows ? windowBaseSpace : baseSpace;
    let center_width = Math.min(space, max_center_width);
    let pos_x = 0;

    if (collidates(pos_x, space)) {
      const m = maxIntervall(pos_x, space);
      const size = m[1] - m[0];
      if (size > 3) {
        const delta = size - 3;
        m[0] += delta / 2;
        m[1] -= delta / 2;
      }
      center_width = Math.min(3, size);
      pos_x = m[0] + center_width / 2;
    }
    return { center_width, pos_x };
  }

  let has_windows = windowBaseSpace >= min_center_width;

  let { center_width, pos_x } = findDoor(has_windows);
  if (center_width < min_center_width && has_windows) {
    has_windows = !has_windows;
    const second = findDoor(has_windows);
    center_width = second.center_width;
    pos_x = second.pos_x;
    if (center_width < min_center_width) {
      has_windows = true;
    }
  }

  if (center_width >= min_center_width) {
    create_front_deko(pos_x, 1.025, center_width, 2.05, 0, "front", "null");
  }

  if (has_windows) {
    const offset = min_wall_space + window_space + window_width / 2;
    [-house_width / 2 + offset, house_width / 2 - offset]
      .filter((x) => !collidates(x, window_width))
      .forEach((x) => {
        create_front_deko(x, 1.425, window_width, window_height, 0, "front", "null");
      });
  }
  if (house_depth > 3) {
    create_front_deko(
      -house_depth * 0.25,
      2.85,
      window_width,
      window_height,
      0,
      "side_left",
      "null"
    );
    create_front_deko(
      house_depth * 0.25,
      2.85,
      window_width,
      window_height,
      0,
      "side_left",
      "null"
    );
    create_front_deko(
      -house_depth * 0.25,
      2.85,
      window_width,
      window_height,
      0,
      "side_right",
      "null"
    );
    create_front_deko(
      house_depth * 0.25,
      2.85,
      window_width,
      window_height,
      0,
      "side_right",
      "null"
    );
  }
  HouseBody_A_mesh.name = "house_body";
  houseTemplate.add(Sockel_A_mesh);
  houseTemplate.add(HouseBody_A_mesh);

  const traverseAndConvertAllGeometryToBufferGeometry = (object) => {
    object.traverse((o) => {
      if (o.geometry && o.geometry instanceof Geometry) {
        o.geometry = o.geometry.toBufferGeometry();
      }
    });
    return object;
  };

  return traverseAndConvertAllGeometryToBufferGeometry(houseGroup);
}
